// extracted by mini-css-extract-plugin
export var active = "_ef-7";
export var container = "_ef-0";
export var evenWidth = "_ef-4";
export var large = "_ef-5";
export var outlet = "_ef-8";
export var slide = "_ef-2";
export var small = "_ef-6";
export var tab = "_ef-3";
export var tabs = "_ef-1";